<template>
  <main-layout
    class="damage"
    page-title="已发布灾害列表"
    custom-back
    @listen-back="goBack"
  >
    <div slot="main-content" class="main-content">
      <div class="centerBox">
        <div class="damageSelect">
          <el-select
            no-data-text="暂无类型"
            clearable
            v-model="queryParams.disasterType"
            placeholder="请选择灾害类型"
            size="medium"
            @change="selectChange"
          >
            <el-option
              v-for="(val, key) in damage_type"
              :key="key"
              :label="val"
              :value="key"
            >
            </el-option>
          </el-select>
        </div>
        <table-list
          ref="tabList"
          class="tablelist"
          :is-show="apiData"
          :list="dataList"
          :loading="tableLoading"
        />
        <pagiation
          :total="total"
          :pageSize="queryParams.pageSize"
          :pageNo="queryParams.pageNo"
          @currentChange="currentChange"
          :pagisShow="apiData"
          v-show="apiData"
        />
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import TableList from "./IndexTableList/index";
import Pagiation from "@/components/Pagiation.vue";
import { getDamageList } from "@/api/request/snkd.produce";
import sameIn from "@/mixins/listsdetails";
import { damage_type } from "@/confing/map_tab.js";
import { windowHref } from "@/utils";

export default {
  name: "index",
  mixins: [sameIn],
  components: {
    MainLayout,
    TableList,
    Pagiation,
  },
  data() {
    return {
      queryParams: {
        disasterType: "",
        pageNo: 1,
        pageSize: 10,
      },
      damage_type,
      dataList: [],
      total: 0,
      tableLoading: false,
      apiData: true,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      const params = {
        farmId: this.farmId,
        ...this.queryParams,
      };
      getDamageList(params).then((res) => {
        if (res.respCode === 0) {
          this.dataList = res.obj.list;
          this.total = res.obj.totalCount;
          this.apiData = !!this.dataList.length;
        }
        this.tableLoading = false;
      });
    },
    goBack() {
      windowHref("/home/home");
    },
    selectChange() {
      this.queryParams.pageNo = 1;
      this.getList();
    },
    currentChange(pageNo) {
      this.queryParams.pageNo = pageNo;
      this.getList();
    },
  },
};
</script>

<style scoped lang="scss">
.damage {
  .main-content {
    width: 1200px;
    height: 100%;
    background: #fff;
    margin: 0 auto;
    .centerBox {
      background-color: #fff;
      min-height: calc(100vh - 80px);
      .tablelist {
        padding: 0 30px 30px 30px;
        min-height: calc(100vh - 315px) !important;
      }
      .damageSelect {
        padding: 20px 0;
        margin: 0 30px;
        border-bottom: 1px solid #dcdfe6;
      }
      ::v-deep .el-table {
        height: 100%;
        .el-table__body-wrapper {
          position: relative;
          height: calc(100% - 80px);
          table {
            padding-bottom: 0 !important;
          }
        }
      }
      ::v-deep .el-select .el-input__inner {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  ::v-deep.el-table {
    border: 0;
    th,
    tr,
    td {
      border: 0;
    }
    &::before {
      height: 0px;
    }
  }
}

// 表格行样式
::v-deep .statistics-warning-row {
  background: $--color-tablist;
}

// 滚动条样式
::v-deep .bscroll-indicator {
  background-color: #dcdfe6 !important;
}
::v-deep .bscroll-vertical-scrollbar {
  z-index: 1 !important;
}

//表头高度
::v-deep .el-table__header tr,
.el-table__header th {
  height: 60px;
}
// 行背景色
::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff !important;
}

::v-deep .el-table__row {
  height: 62px;
}
::v-deep .el-table td,
.el-table th.is-leaf {
  border: none;
}
// 表格最外边框
.el-table--border,
.el-table--group {
  border: none;
}
// 加载圈
::v-deep .el-loading-mask {
  z-index: 1;
}
</style>
